import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginationModel } from '../models/pagination-model';
import { StorageService } from './storage.service';


@Injectable({ providedIn: 'root' })
export class ClienteService {



    public stores: any[];
    public selectedStore: any;

    private readonly apiUrl = environment.apiEndpoint + 'cliente';

    constructor(
        private http: HttpClient,
        private storageService: StorageService
    ) { }


    getClientes(pageNum: number, pageSize: number, palabraClave: string): Observable<PaginationModel> {
        let finalurl = this.apiUrl + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }

    getAllClientes(): Observable<any[]> {
        let finalurl = this.apiUrl + '/getAll'
        return this.http.get<any[]>(finalurl, { withCredentials: true });
    }

    getBillingClients(pageNum: number, pageSize: number, palabraClave: string, filterType: string = 'all'): Observable<PaginationModel> {
        let finalurl = this.apiUrl + '/billing?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave + '&filterType=' + filterType;
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }

    getBillingDetail(idCliente: string, pageNum: number, pageSize: number, palabraClave: string): Observable<PaginationModel> {
        let finalurl = this.apiUrl + '/' + idCliente + '/billingDetail?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }

    syncCardsEndDate(idCliente: string | number): Observable<any> {
        let finalurl = this.apiUrl + '/' + idCliente + '/sync-cards-end-date';
        return this.http.put<any>(finalurl, {}, { withCredentials: true });
    }

    renewCards(idCliente: string | number): Observable<any> {
        let finalurl = this.apiUrl + '/' + idCliente + '/renew-cards';
        return this.http.put<any>(finalurl, {}, { withCredentials: true });
    }

    updateMasterCardDate(idTarjeta: string | number, endDate: Date | string): Observable<any> {
        let finalurl = environment.apiEndpoint + 'tarjeta/' + idTarjeta + '/update-end-date';
        return this.http.put<any>(finalurl, { endDate: endDate }, { withCredentials: true });
    }

    updateBilledStatus(idTarjeta: string | number, status: boolean): Observable<any> {
        let finalurl = environment.apiEndpoint + 'tarjeta/' + idTarjeta + '/update-billed-status';
        return this.http.put<any>(finalurl, { billed: status }, { withCredentials: true });
    }

    updateCroaBilledStatus(idTarjeta: string | number, status: boolean): Observable<any> {
        let finalurl = environment.apiEndpoint + 'tarjeta/' + idTarjeta + '/update-croa-billed-status';
        return this.http.put<any>(finalurl, { croaBilled: status }, { withCredentials: true });
    }

    getExpiringMasterCards(): Observable<any[]> {
        let finalurl = environment.apiEndpoint + 'tarjeta/expiring-master-cards';
        return this.http.get<any[]>(finalurl, { withCredentials: true });
    }



    getClientesById(idTaller: string): Observable<any> {
        return this.http.get<PaginationModel>(this.apiUrl + '/' + idTaller, { withCredentials: true });
    }

    getTallerToEditById(idTaller: string): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/data/' + idTaller, { withCredentials: true });
    }

    saveCliente(clienteForm: FormData): Observable<any> {
        return this.http.post<any>(this.apiUrl, clienteForm, { withCredentials: true });
    }

    createTaller(tallerData: FormData): Observable<any> {
        return this.http.post(this.apiUrl, tallerData);
    }

    updateTaller(idTaller: string, tallerData: FormData): Observable<any> {
        return this.http.put(this.apiUrl + '/' + idTaller, tallerData);
    }

    deleteTaller(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/' + id, { withCredentials: true });
    }


    getTalleresByIdUser(): Observable<any[]> {
        return this.http.get<any>(this.apiUrl + '/stores', { withCredentials: true });
    }


}
